import React, { useContext } from "react";
import { Auth0Provider } from '@auth0/auth0-react'
import { Routes } from '../routes';
import { AppContext } from '../contexts';
import ServerPollingGate from '../polling/ServerPollingGate';

const ContextualizedApp = () => {

    const { appConfiguration } = useContext(AppContext);

    //console.info('Moduli attivi in ContextualizedApp - se non trovi il tuo modulo al 99% non lo hai linkato in index.js di root di mtska-frontend-modules', appConfiguration.modules.active)

    return (
        <Auth0Provider
            domain={appConfiguration.auth0.DOMAIN}
            clientId={appConfiguration.auth0.CLIENT_ID}
            cacheLocation="localstorage"
            useRefreshTokens={true}
            authorizationParams={{
                redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI || appConfiguration.auth0.REDIRECT_URI,
            }}
        >
            <ServerPollingGate />
            <Routes modules={appConfiguration.modules.active} />
        </Auth0Provider>
    )

}

export default ContextualizedApp;
